export const env = {
  carrefour: {
    token: btoa(JSON.stringify({
      supplierId: 24,
      origin: "carrefour",
      domain: "miam.carrefour.web",
    })),
  },
  coursesu: {
    token: btoa(JSON.stringify({
      supplierId: 7,
      origin: "coursesu",
      domain: globalThis.location.href.includes("https://www.coursesu.com/") ? "miam.coursesu.web" : "miam.test",
      noSupplier: false,
      orderHistory: true,
    })),
  },
  monoprix: {
    domain: 'miam.monoprix.web',
    alSupplierId: 10,
    nonalSupplierId: 11
  },
  ssr: {
    baseUrl: 'https://ssr-api.mealz.ai',
  }
};